/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  SampleRecipient,
  SampleRecipientInterface,
} from "../SampleRecipient";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_msgSenderFunc",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "Sender",
    type: "event",
  },
  {
    inputs: [],
    name: "getTrustedForwarder",
    outputs: [
      {
        internalType: "address",
        name: "forwarder",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarder",
        type: "address",
      },
    ],
    name: "isTrustedForwarder",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarder",
        type: "address",
      },
    ],
    name: "setForwarder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "something",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "nothing",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "0x608060405234801561001057600080fd5b506101c9806100206000396000f3fe608060405234801561001057600080fd5b50600436106100575760003560e01c8063448f30a31461005c578063572b6c0514610066578063a7a0d5371461005c578063b9998a241461009d578063ce1b815f146100c9575b600080fd5b6100646100e4565b005b610088610074366004610163565b6000546001600160a01b0391821691161490565b60405190151581526020015b60405180910390f35b6100646100ab366004610163565b600080546001600160a01b0319166001600160a01b03831617905550565b6000546040516001600160a01b039091168152602001610094565b7f2960695afa2609b7591ca0b79d5586f853e610ce0515852f7a5ced78fd32ade961010d61012f565b604080516001600160a01b0390921682523360208301520160405180910390a1565b60006014361080159061014c57506000546001600160a01b031633145b1561015e575060131936013560601c90565b503390565b60006020828403121561017557600080fd5b81356001600160a01b038116811461018c57600080fd5b939250505056fea264697066735822122050eed84f8d342ec2dff522bada9ba2304b76c9b31c438b76ee2a488e231d394e64736f6c63430008070033";

type SampleRecipientConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: SampleRecipientConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class SampleRecipient__factory extends ContractFactory {
  constructor(...args: SampleRecipientConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: string }
  ): Promise<SampleRecipient> {
    return super.deploy(overrides || {}) as Promise<SampleRecipient>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: string }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): SampleRecipient {
    return super.attach(address) as SampleRecipient;
  }
  override connect(signer: Signer): SampleRecipient__factory {
    return super.connect(signer) as SampleRecipient__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): SampleRecipientInterface {
    return new utils.Interface(_abi) as SampleRecipientInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): SampleRecipient {
    return new Contract(address, _abi, signerOrProvider) as SampleRecipient;
  }
}
